import FlightIcon from "@mui/icons-material/Flight";

export const flight = (props) => {
  return <FlightIcon {...props} />;
};
